<router-outlet />
<p-toast
  [breakpoints]="{
    '920px': { width: 'calc(100% - 24px)', right: '12px', left: '12px' },
  }"
/>

<yt-confirm-dialog dialogKey="general" />
